<template>
  <div class="date-range-input clearfix">
    <div class="form-group" :class="{ 'has-feedback' : field.dirty }">
      <label class="col-sm-4 control-label">{{ field.label }} <span v-if="field.required" class="required">*</span></label>
      <div class="col-sm-8">
        <input type='text' :name="field.name" class="form-control" v-model="field.value" v-el:date/>
        <span class="form-validation-error" v-if="!field.valid && field.dirty">Date entered is not valid.</span>
        <span class="fa fa-check form-control-feedback form-control-feedback-success form-control-feedback-select" v-if="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback form-control-feedback-error form-control-feedback-select" v-if="!field.valid && field.dirty"></span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'DateInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          type: 'date',
          value: '',
          toValue: ''
        }
      }
    }
  },
  data () {
    return {
      datePicker: {}
    }
  },
  ready () {
    if (moment(this.field.value, 'D/M/Y').format() === 'Invalid date') {
      this.field.value = moment(this.field.value).format('D/M/Y')
    }
    this.datePicker = new Pikaday({
      field: this.$els.date,
      format: 'D/M/Y',
      yearRange: [1920, 2030]
    })
    this.$nextTick(() => {
      let date = moment(this.field.value, 'D/M/Y').toDate()
      this.datePicker.gotoDate(date)
      this.datePicker.setDate(date)
    })
  },
  watch: {
    'field.value': {
      handler: function (newVal, oldVal) {
        this.validateField(newVal)
      }
    }
  },
  methods: {
    validateField (val) {
      if (this.field.required && val === '') {
        this.field.valid = false
      }
      if (!this.field.required && val === '') {
        this.field.value = ''
        this.field.valid = true
        this.field.dirty = false
      }
      if (val !== '') {
        this.field.dirty = true
        let m = moment(val, 'D/M/Y')
        this.field.value = m.format('D/M/Y')
        this.field.valid = this.field.value !== 'Invalid date'
        if (this.field.minDate && this.field.maxDate) {
          this.field.valid = m.isAfter(this.field.minDate) && m.isBefore(this.field.maxDate)
        } else if (this.field.minDate) {
          this.field.valid = m.isAfter(this.field.minDate)
        } else if (this.field.maxDate) {
          this.field.valid = m.isBefore(this.field.maxDate)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// DateInput.vue?1cf09311